import { render, staticRenderFns } from "./TaxPaymentForm.vue?vue&type=template&id=1438d89e&scoped=true&"
import script from "./TaxPaymentForm.vue?vue&type=script&lang=js&"
export * from "./TaxPaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxPaymentForm.vue?vue&type=style&index=0&id=1438d89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438d89e",
  null
  
)

component.options.__file = "TaxPaymentForm.vue"
export default component.exports